export const getBrowserName = ():
  | 'brave'
  | 'chrome'
  | 'firefox'
  | 'opera'
  | 'safari'
  | 'samsung' => {
  const userAgent = navigator.userAgent.toLowerCase()

  if (userAgent.includes('brave')) {
    return 'brave'
  } else if (userAgent.includes('firefox')) {
    return 'firefox'
  } else if (userAgent.includes('opera') || userAgent.includes('opr')) {
    return 'opera'
  } else if (userAgent.includes('samsung')) {
    return 'samsung'
  } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    return 'safari'
  }

  return 'chrome'
}
